import { render } from "./PageStrategyDetail.vue?vue&type=template&id=69ed8ea4"
import script from "./PageStrategyDetail.vue?vue&type=script&lang=js"
export * from "./PageStrategyDetail.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__